import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LandingComponent } from './landing/landing.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { SignInComponent } from './sign-in/sign-in.component';

const routes: Routes = [
  {
    // Add infomercial pages here.
    path: '',
    component: LandingComponent,
    children: [
      {
        path: '',
        component: SignInComponent,
      },

      {
        path: 'password-reset',
        component: PasswordResetComponent,
      },
      {
        path: 'password-reset/:token',
        component: PasswordResetComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
